import { createAction } from '@reduxjs/toolkit';
import { responseFailed } from './error';
import { showHideLoader } from './loader';

export const getOffer = createAction('case/getOffer', function prepare(caseId) {
  return {
    payload: {
      endPoint: `banks/:bankId/cases/personal-loan/${caseId}/offer`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: getOfferSuccess,
      failure: responseFailed,
      version: '1.2.0',
      useEnvTag: true
    }
  };
});

export const updateOffer = createAction(
  'case/updateOffer',
  function prepare({ caseId, offerId, day }) {
    return {
      payload: {
        endPoint: `banks/:bankId/cases/personal-loan/${caseId}/offers/${offerId}`,
        method: 'put',
        body: {
          id: offerId,
          repayment: {
            payment_due_day: day
          }
        },
        isPaasApi: true,
        addHeader: true,
        success: updateOfferSuccess,
        successParam: {
          caseId
        },
        failure: responseFailed,
        version: '1.2.0',
        useEnvTag: true
      }
    };
  }
);

export const updateOfferSuccessResponse = createAction(
  'case/updateOfferSuccessResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

export const updateOfferSuccess = (response, param) => (dispatch) => {
  dispatch(updateOfferSuccessResponse(response));
  dispatch(getOffer(param.caseId));
};

export const getOfferSuccess = (response) => (dispatch, getState) => {
  dispatch(getOfferSuccessResponse(response));
  const {
    config: { isJoint }
  } = getState();

  //documents API not require to call for JOINT journey
  if (isJoint) {
    dispatch(showHideLoader(false));
  } else if (response && response.data) {
    const {
      data: {
        offers: { documents }
      }
    } = response;

    if (documents && documents.length > 0) {
      dispatch(setOfferDocument(documents.length));
      documents.forEach(({ id, type, format }) => {
        dispatch(getOfferDocument(id, type, format));
      });
    } else {
      dispatch(
        responseFailed({
          message: 'Offer success: No documents found'
        })
      );
    }
  }
};

export const getOfferSuccessResponse = createAction(
  'case/getOfferSuccessResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

const getOfferDocument = createAction(
  'case/getOfferDocument',
  function prepare(docId, type, format) {
    return {
      payload: {
        endPoint: `banks/:bankId/documents/${docId}?product=PERSONALLOANS`,
        method: 'get',
        isPaasApi: true,
        addHeader: true,
        success: getOfferDocumentSuccess,
        successParam: {
          docId,
          type,
          format
        },
        failure: responseFailed,
        version: '1.0.0',
        useEnvTag: false
      }
    };
  }
);

const getOfferDocumentSuccess = (response, docParam) => (dispatch) => {
  dispatch(getOfferDocumentSuccessResponse(response, docParam));
  dispatch(updateOfferDocumentCount());
};

export const getOfferDocumentSuccessResponse = createAction(
  'case/getOfferDocumentSuccessResponse',
  function prepare(response, docParam) {
    return {
      payload: {
        response,
        docParam
      }
    };
  }
);

export const setOfferDocument = createAction('case/setOfferDocument', function prepare(count) {
  return {
    payload: count
  };
});

/**
 * @todo probably doesn't need a payload
 */
export const updateOfferDocumentCount = createAction(
  'case/updateOfferDocumentCount',
  function prepare() {
    return {
      payload: null
    };
  }
);

export const setTakeLoanSubmitFlag = createAction(
  'case/setTakeLoanSubmitFlag',
  function prepare(isSubmit) {
    return {
      payload: isSubmit
    };
  }
);
